import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Paper, TextField } from '@material-ui/core';
import GoToButton from '../components/GoToButton';
import ActionButton from '../../../components/ActionButton';

import { AUTH_OPTIONS, AUTH_TYPES } from '../../../auth/auth.options';
import AuthTypeSelector from '../components/AuthTypeSelector';
import PasswordFieldsCollapse from '../components/PasswordFieldsCollapse';

const styles = {
  sectionContainer: {
    margin: '16px 0',
    padding: '24px',
    width: '100%',
    maxWidth: 980,
  },
  innerContainer: {
    marginTop: '10px',
    marginBottom: '10px',
    padding: '8px 32px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textfield: {
    width: '320px',
    marginBottom: '12px',
  },
  buttonContainer: {
    marginTop: '24px',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
};

export default class FormRegistrazioneConsulenteGruppo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword1: false,
      showPassword2: false,
    };
  }

  handleClickShowPassword1 = () => {
    let flag = this.state.showPassword1;
    this.setState({
      showPassword1: !flag,
    });
  };

  handleClickShowPassword2 = () => {
    let flag = this.state.showPassword2;
    this.setState({
      showPassword2: !flag,
    });
  };

  render() {
    const authType = this.props.consulente.passwordEnabled
      ? AUTH_TYPES.LOCAL
      : AUTH_TYPES.MICROSOFT_SSO;

    const isLocalAuth = authType === AUTH_TYPES.LOCAL;

    const errors =
      this.props.validationErrors.email.length > 0 ||
      this.props.validationErrors.password.length > 0 ||
      this.props.validationErrors.confirmPassword.length > 0;

    return (
      <form autoComplete="off" onSubmit={this.props.onSubmit}>
        <Grid container justify="center">
          <Paper style={styles.sectionContainer}>
            <Grid container style={styles.innerContainer}>
              <AuthTypeSelector
                value={authType}
                options={AUTH_OPTIONS}
                onChange={this.props.onAuthTypeChange}
                disabled={this.props.disabled}
              />
              <Grid item xs={12} md={6} style={styles.column}>
                <TextField
                  label="Email"
                  required
                  value={this.props.consulente.email}
                  id="consulente-email"
                  name="email"
                  onChange={this.props.onChange}
                  disabled={this.props.disabled}
                  style={styles.textfield}
                  helperText={this.props.validationErrors.email}
                  error={this.props.validationErrors.email.length > 0}
                />
                <PasswordFieldsCollapse
                  open={isLocalAuth}
                  disabled={this.props.disabled}
                  required={isLocalAuth}
                  passwordValue={this.props.consulente.password}
                  confirmPasswordValue={this.props.consulente.confirmPassword}
                  passwordError={this.props.validationErrors.password}
                  confirmPasswordError={
                    this.props.validationErrors.confirmPassword
                  }
                  showPassword1={this.state.showPassword1}
                  showPassword2={this.state.showPassword2}
                  onToggleShowPassword1={this.handleClickShowPassword1}
                  onToggleShowPassword2={this.handleClickShowPassword2}
                  onChange={this.props.onChange}
                />

                <TextField
                  label="Nome"
                  value={this.props.consulente.nome}
                  id="consulente-nome"
                  name="nome"
                  onChange={this.props.onChange}
                  disabled={this.props.disabled}
                  style={styles.textfield}
                />
                <TextField
                  label="Cognome"
                  value={this.props.consulente.cognome}
                  id="consulente-cognome"
                  name="cognome"
                  onChange={this.props.onChange}
                  disabled={this.props.disabled}
                  style={styles.textfield}
                />
              </Grid>
              <Grid item xs={12} md={6} style={styles.column}>
                <TextField
                  label="Telefono"
                  value={this.props.consulente.telefono}
                  id="consulente-telefono"
                  name="telefono"
                  onChange={this.props.onChange}
                  disabled={this.props.disabled}
                  style={styles.textfield}
                />
                <TextField
                  label="Partita IVA"
                  value={this.props.consulente.partitaIva}
                  id="consulente-partita-iva"
                  name="partitaIva"
                  onChange={this.props.onChange}
                  disabled={this.props.disabled}
                  style={styles.textfield}
                />
                <TextField
                  label="Codice SDI"
                  value={this.props.consulente.codiceSdi}
                  id="consulente-codice-sdi"
                  name="codiceSdi"
                  onChange={this.props.onChange}
                  disabled={this.props.disabled}
                  style={styles.textfield}
                />
                <TextField
                  label="PEC"
                  value={this.props.consulente.pec}
                  id="consulente-pec"
                  name="pec"
                  onChange={this.props.onChange}
                  disabled={this.props.disabled}
                  style={styles.textfield}
                />
              </Grid>
            </Grid>
          </Paper>
          <div style={styles.buttonContainer}>
            <GoToButton
              showAlert={this.props.changesNotSaved}
              path={'/amministrazione/gruppi/' + this.props.consulente.gruppoId}
              label="Torna alla pagina di modifica del gruppo"
              secondaryButton
              disabled={false}
              grayVersion={false}
            />
            <ActionButton
              label="Registra"
              disabled={
                this.props.disabled || errors || this.props.submitDisabled
              }
              onClick={this.props.onSubmit}
              grayVersion={false}
            />
          </div>
        </Grid>
      </form>
    );
  }
}

FormRegistrazioneConsulenteGruppo.propTypes = {
  consulente: PropTypes.object.isRequired,
  onAuthTypeChange: PropTypes.func.isRequired,
  validationErrors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitDisabled: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  changesNotSaved: PropTypes.bool.isRequired,
};
